import { Postulacion } from '../models/postulaciones.models';

export const POSTULACIONES_MOCK: Postulacion[] = [
  {
    idPostulacion: 'P-1001',
    concurso: 'Proyectos de Investigacion',
    nombreProyecto: 'Optimizacion de sistemas de riego inteligente',
    subdireccion: 'INVESTIGACION APLICADA',
    departamentoFacultad: 'Facultad de Ingenieria',
    estadoConcurso: 'abierto',
    folio: '500001',
    trackingUrl: 'https://www.anid.cl/tracking/500001',
    estadoPostulacion: 'en_preparacion',
    anio: 2026,
    fechaInicio: '2026-02-10',
    fechaTermino: '2026-05-30',
    rolesPermitidos: ['postulante', 'ayudante_postulante', 'representante_institucional', 'ayudante_representante'],
    enviadaPorPostulante: false,
    editablePorAyudante: true,
    estadoInvitacion: 'aceptada',
    estadoPatrocinio: 'patrocinado',
    solicitudPatrocinio: true,
    avancePorcentaje: 35,
    asignadaAnalista: true,
  },
  {
    idPostulacion: 'P-1002',
    concurso: 'Redes de Investigacion',
    nombreProyecto: 'Red nacional de sensores oceanograficos',
    subdireccion: 'INVESTIGACION APLICADA',
    departamentoFacultad: 'Facultad de Ciencias del Mar',
    estadoConcurso: 'abierto',
    folio: '500009',
    trackingUrl: 'https://www.anid.cl/tracking/500009',
    estadoPostulacion: 'adjudicado',
    anio: 2026,
    fechaInicio: '2026-01-15',
    fechaTermino: '2026-04-25',
    rolesPermitidos: ['postulante', 'ayudante_postulante', 'representante_institucional', 'ayudante_representante'],
    enviadaPorPostulante: true,
    editablePorAyudante: false,
    estadoInvitacion: 'aceptada',
    estadoPatrocinio: 'patrocinado',
    solicitudPatrocinio: true,
    avancePorcentaje: 100,
    asignadaAnalista: true,
  },
  {
    idPostulacion: 'P-1003',
    concurso: 'Capital Humano',
    nombreProyecto: 'Becas doctorado en IA aplicada',
    subdireccion: 'INVESTIGACION APLICADA',
    departamentoFacultad: 'Escuela de Postgrado',
    estadoConcurso: 'abierto',
    folio: '500012',
    trackingUrl: 'https://www.anid.cl/tracking/500012',
    estadoPostulacion: 'en_preparacion',
    anio: 2026,
    fechaInicio: '2026-03-01',
    fechaTermino: '2026-06-10',
    rolesPermitidos: ['postulante', 'ayudante_postulante'],
    enviadaPorPostulante: false,
    editablePorAyudante: true,
    estadoInvitacion: 'no_aplica',
    estadoPatrocinio: 'no_aplica',
    solicitudPatrocinio: false,
    avancePorcentaje: 20,
    asignadaAnalista: false,
  },
  {
    idPostulacion: 'P-1004',
    concurso: 'Centros de Excelencia',
    nombreProyecto: 'Centro interdisciplinario de transicion energetica',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
    departamentoFacultad: 'Facultad de Energia',
    estadoConcurso: 'abierto',
    folio: '500030',
    trackingUrl: 'https://www.anid.cl/tracking/500030',
    estadoPostulacion: 'en_preparacion',
    anio: 2026,
    fechaInicio: '2026-02-20',
    fechaTermino: '2026-07-15',
    rolesPermitidos: ['postulante', 'ayudante_postulante', 'representante_institucional', 'ayudante_representante'],
    enviadaPorPostulante: false,
    editablePorAyudante: false,
    estadoInvitacion: 'rechazada',
    estadoPatrocinio: 'sin_patrocinio',
    solicitudPatrocinio: true,
    avancePorcentaje: 10,
    asignadaAnalista: true,
  },
  {
    idPostulacion: 'P-1005',
    concurso: 'Programa I+D Regional',
    nombreProyecto: 'Laboratorio de manufactura avanzada',
    subdireccion: 'INVESTIGACION APLICADA',
    departamentoFacultad: 'Facultad de Ingenieria',
    estadoConcurso: 'cerrado',
    folio: '500041',
    trackingUrl: 'https://www.anid.cl/tracking/500041',
    estadoPostulacion: 'en_revision',
    anio: 2025,
    fechaInicio: '2025-10-01',
    fechaTermino: '2025-12-12',
    rolesPermitidos: ['postulante', 'ayudante_postulante', 'representante_institucional'],
    enviadaPorPostulante: true,
    editablePorAyudante: false,
    estadoInvitacion: 'aceptada',
    estadoPatrocinio: 'patrocinado',
    solicitudPatrocinio: true,
    avancePorcentaje: 100,
    asignadaAnalista: false,
  },
  {
    idPostulacion: 'P-1006',
    concurso: 'Redes de Investigacion',
    nombreProyecto: 'Plataforma de analitica para salud publica',
    subdireccion: 'INVESTIGACION APLICADA',
    departamentoFacultad: 'Facultad de Medicina',
    estadoConcurso: 'abierto',
    folio: '500055',
    trackingUrl: 'https://www.anid.cl/tracking/500055',
    estadoPostulacion: 'en_preparacion',
    anio: 2026,
    fechaInicio: '2026-04-03',
    fechaTermino: '2026-07-30',
    rolesPermitidos: ['postulante', 'ayudante_postulante', 'ayudante_representante'],
    enviadaPorPostulante: false,
    editablePorAyudante: true,
    estadoInvitacion: 'no_aplica',
    estadoPatrocinio: 'sin_patrocinio',
    solicitudPatrocinio: true,
    avancePorcentaje: 50,
    asignadaAnalista: true,
  },
  {
    idPostulacion: 'P-1007',
    concurso: 'Proyectos de Investigacion',
    nombreProyecto: 'Sistemas de monitoreo para bosques nativos',
    subdireccion: 'INVESTIGACION APLICADA',
    departamentoFacultad: 'Facultad de Ciencias Forestales',
    estadoConcurso: 'abierto',
    folio: '500061',
    trackingUrl: 'https://www.anid.cl/tracking/500061',
    estadoPostulacion: 'en_revision',
    anio: 2026,
    fechaInicio: '2026-03-15',
    fechaTermino: '2026-08-20',
    rolesPermitidos: ['representante_institucional', 'ayudante_representante'],
    enviadaPorPostulante: true,
    editablePorAyudante: false,
    estadoInvitacion: 'aceptada',
    estadoPatrocinio: 'sin_patrocinio',
    solicitudPatrocinio: true,
    avancePorcentaje: 100,
  },
  {
    idPostulacion: 'P-1008',
    concurso: 'Capital Humano',
    nombreProyecto: 'Programa nacional de pasantias cientificas',
    subdireccion: 'CAPITAL HUMANO',
    departamentoFacultad: 'Direccion de Vinculacion',
    estadoConcurso: 'abierto',
    folio: '500072',
    trackingUrl: 'https://www.anid.cl/tracking/500072',
    estadoPostulacion: 'adjudicado',
    anio: 2026,
    fechaInicio: '2026-01-05',
    fechaTermino: '2026-03-30',
    rolesPermitidos: ['postulante', 'ayudante_postulante'],
    enviadaPorPostulante: true,
    editablePorAyudante: false,
    estadoInvitacion: 'no_aplica',
    estadoPatrocinio: 'no_aplica',
    solicitudPatrocinio: false,
    avancePorcentaje: 100,
  },
  {
    idPostulacion: 'P-1009',
    concurso: 'Centros de Excelencia',
    nombreProyecto: 'Centro de datos para modelamiento climatico',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
    departamentoFacultad: 'Facultad de Ciencias',
    estadoConcurso: 'abierto',
    folio: '500086',
    trackingUrl: 'https://www.anid.cl/tracking/500086',
    estadoPostulacion: 'en_revision',
    anio: 2026,
    fechaInicio: '2026-02-28',
    fechaTermino: '2026-09-12',
    rolesPermitidos: ['representante_institucional', 'ayudante_representante'],
    enviadaPorPostulante: true,
    editablePorAyudante: false,
    estadoInvitacion: 'rechazada',
    estadoPatrocinio: 'sin_patrocinio',
    solicitudPatrocinio: true,
  },
  {
    idPostulacion: 'P-1010',
    concurso: 'Programa I+D Regional',
    nombreProyecto: 'Biotecnologia aplicada a la agricultura',
    subdireccion: 'INVESTIGACION APLICADA',
    departamentoFacultad: 'Facultad de Agronomia',
    estadoConcurso: 'abierto',
    folio: '500094',
    trackingUrl: 'https://www.anid.cl/tracking/500094',
    estadoPostulacion: 'en_preparacion',
    anio: 2026,
    fechaInicio: '2026-04-10',
    fechaTermino: '2026-10-01',
    rolesPermitidos: ['postulante', 'ayudante_postulante', 'representante_institucional', 'ayudante_representante'],
    enviadaPorPostulante: false,
    editablePorAyudante: true,
    estadoInvitacion: 'aceptada',
    estadoPatrocinio: 'patrocinado',
    solicitudPatrocinio: true,
  },
  {
    idPostulacion: 'P-1011',
    concurso: 'Desarrollo Tecnologico Territorial',
    nombreProyecto: 'Plataforma de telemedicina rural',
    subdireccion: 'INVESTIGACION APLICADA',
    departamentoFacultad: 'Facultad de Medicina',
    estadoConcurso: 'abierto',
    folio: '500103',
    trackingUrl: 'https://www.anid.cl/tracking/500103',
    estadoPostulacion: 'en_preparacion',
    anio: 2026,
    fechaInicio: '2026-04-14',
    fechaTermino: '2026-11-22',
    rolesPermitidos: ['postulante', 'ayudante_postulante'],
    enviadaPorPostulante: false,
    editablePorAyudante: true,
    estadoInvitacion: 'no_aplica',
    estadoPatrocinio: 'no_aplica',
    solicitudPatrocinio: false,
    avancePorcentaje: 45,
  },
  {
    idPostulacion: 'P-1012',
    concurso: 'Redes Internacionales',
    nombreProyecto: 'Nodo latinoamericano de ciberseguridad',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
    departamentoFacultad: 'Facultad de Ingenieria',
    estadoConcurso: 'abierto',
    folio: '500117',
    trackingUrl: 'https://www.anid.cl/tracking/500117',
    estadoPostulacion: 'adjudicado',
    anio: 2026,
    fechaInicio: '2026-05-02',
    fechaTermino: '2026-12-10',
    rolesPermitidos: ['representante_institucional', 'ayudante_representante'],
    enviadaPorPostulante: true,
    editablePorAyudante: false,
    estadoInvitacion: 'aceptada',
    estadoPatrocinio: 'patrocinado',
    solicitudPatrocinio: true,
    avancePorcentaje: 100,
  },
  {
    idPostulacion: 'P-1013',
    concurso: 'Programa de Innovacion Publica',
    nombreProyecto: 'Analitica avanzada para gestion municipal',
    subdireccion: 'INVESTIGACION APLICADA',
    departamentoFacultad: 'Facultad de Administracion Publica',
    estadoConcurso: 'abierto',
    folio: '500121',
    trackingUrl: 'https://www.anid.cl/tracking/500121',
    estadoPostulacion: 'en_revision',
    anio: 2026,
    fechaInicio: '2026-03-18',
    fechaTermino: '2026-10-28',
    rolesPermitidos: ['representante_institucional', 'ayudante_representante'],
    enviadaPorPostulante: true,
    editablePorAyudante: false,
    estadoInvitacion: 'rechazada',
    estadoPatrocinio: 'sin_patrocinio',
    solicitudPatrocinio: true,
  },
  {
    idPostulacion: 'P-1014',
    concurso: 'Capital Humano Avanzado',
    nombreProyecto: 'Becas de especializacion en biotecnologia',
    subdireccion: 'CAPITAL HUMANO',
    departamentoFacultad: 'Escuela de Postgrado',
    estadoConcurso: 'abierto',
    folio: '500138',
    trackingUrl: 'https://www.anid.cl/tracking/500138',
    estadoPostulacion: 'adjudicado',
    anio: 2026,
    fechaInicio: '2026-02-08',
    fechaTermino: '2026-06-25',
    rolesPermitidos: ['postulante', 'ayudante_postulante', 'representante_institucional', 'ayudante_representante'],
    enviadaPorPostulante: true,
    editablePorAyudante: false,
    estadoInvitacion: 'aceptada',
    estadoPatrocinio: 'patrocinado',
    solicitudPatrocinio: true,
    avancePorcentaje: 100,
  },
];
